import { createMuiTheme, responsiveFontSizes } from "@material-ui/core";

let theme = createMuiTheme({
    palette: {
        primary: {
            main:'#000000',
            dark: ""
        },
        secondary: {
            main: "#ffc500",
            dark: ""
        },
        background: {
            main: "#ffffff",
            dark: ""
        }
    }
})

theme = responsiveFontSizes(theme)

export default theme